"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTime = void 0;
const react_1 = require("react");
const dayjs_1 = __importDefault(require("dayjs"));
const utc_1 = __importDefault(require("dayjs/plugin/utc"));
const timezone_1 = __importDefault(require("dayjs/plugin/timezone"));
const advancedFormat_1 = __importDefault(require("dayjs/plugin/advancedFormat"));
dayjs_1.default.extend(utc_1.default);
dayjs_1.default.extend(timezone_1.default);
dayjs_1.default.extend(advancedFormat_1.default);
exports.DateTime = (0, react_1.memo)(({ datetime, format = "YYYY-MM-DD HH:mm z" }) => {
    const dayjsDateTime = dayjs_1.default.utc(datetime);
    return (dayjsDateTime.isValid()
        ? dayjsDateTime.tz().format(format)
        : "INVALID_DATE");
});
